/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @version 1.0.0
 * @since 1.0.0
 */

import { LinkBlock } from '../../../../components/common/index';
import { ISuperSearchTranslation } from '../../../internationalization/types/corporate';
import {
    SuperSearchListGroupStyled,
    SuperSearchListItemStub,
} from '../styled/SuperSearchListStyled';

export interface ISuperSearchItemErrorProps {
    startSearch: () => void;
    translation: ISuperSearchTranslation;
}

const SuperSearchItemError = ({ startSearch, translation }: ISuperSearchItemErrorProps) => {
    return (
        <SuperSearchListGroupStyled>
            <SuperSearchListItemStub>
                {translation.notLoad}
                <LinkBlock onClick={startSearch}> 
                    {translation.repeat}
                </LinkBlock>
            </SuperSearchListItemStub>
        </SuperSearchListGroupStyled>
    );
};

export default SuperSearchItemError;
